var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Defaults from '../Defaults';
import { MenuTargets } from '../Constants';
import { DeliveryLocationGroupFormModel } from '.';
import { LocationGroupRepository, } from '@/models/LocationGroup';
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants';
import { cloneDeep } from 'lodash';
var defaults = Defaults.MenuSetting;
var GeoTargetingMenuSettingFormModel = /** @class */ (function () {
    function GeoTargetingMenuSettingFormModel(menuSetting, profileIds) {
        if (menuSetting === void 0) { menuSetting = {}; }
        if (profileIds === void 0) { profileIds = {}; }
        var _a = menuSetting, id = _a.id, _b = _a.target, target = _b === void 0 ? defaults.target : _b, _c = _a.minutesAgo, minutesAgo = _c === void 0 ? defaults.minutesAgo : _c, _d = _a.visitCount, visitCount = _d === void 0 ? defaults.visitCount : _d, _e = _a.enableRadiusAutomation, enableRadiusAutomation = _e === void 0 ? defaults.enableRadiusAutomation : _e, _f = _a.useLowQualityLocation, useLowQualityLocation = _f === void 0 ? defaults.useLowQualityLocation : _f, _g = _a.radius, radius = _g === void 0 ? defaults.radius : _g, _h = _a.enableBulkSetting, enableBulkSetting = _h === void 0 ? defaults.enableBulkSetting : _h, _j = _a.deliveryLocationGroups, deliveryLocationGroups = _j === void 0 ? [] : _j;
        this.id = id;
        this.target = target;
        this.minutesAgo = minutesAgo;
        this.visitCount = visitCount;
        this.enableRadiusAutomation = enableRadiusAutomation;
        this.originalEnableRadiusAutomation = enableRadiusAutomation;
        this.useLowQualityLocation = useLowQualityLocation;
        this.radius = radius;
        this.enableBulkSetting = enableBulkSetting;
        this.deliveryLocationGroups = deliveryLocationGroups.map(function (group) {
            return DeliveryLocationGroupFormModel.assign(group);
        });
        if (this.enableBulkSetting) {
            this.setRadiusToAllRadiusTarget(this.radius);
        }
        this.oemLocationGroups = [];
        this.advertiserLocationGroups = [];
        this.insertionOrderLocationGroups = [];
        this.simulationLocationGroups = deliveryLocationGroups
            .filter(function (g) { return g.isSimulation; })
            .sort(this.sortUsableGroupToTop);
        var _k = profileIds, systemOwnerProfileId = _k.systemOwnerProfileId, advertiserOwnerProfileId = _k.advertiserOwnerProfileId, insertionOrderOwnerProfileId = _k.insertionOrderOwnerProfileId;
        this.systemOwnerProfileId = systemOwnerProfileId;
        this.advertiserOwnerProfileId = advertiserOwnerProfileId;
        this.insertionOrderOwnerProfileId = insertionOrderOwnerProfileId;
        this.originalDeliveryLocationGroups = cloneDeep(this.deliveryLocationGroups);
    }
    GeoTargetingMenuSettingFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // 初期化処理
                    return [4 /*yield*/, this.fetchLocationGroups()];
                    case 1:
                        // 初期化処理
                        _a.sent();
                        this.addAccessibleType();
                        return [2 /*return*/];
                }
            });
        });
    };
    GeoTargetingMenuSettingFormModel.prototype.setTargetCode = function (target) {
        this.target = target;
    };
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "isUnderMinRadius", {
        get: function () {
            return this.radius < GeoTargetingMenuSettingFormModel.MIN_RADIUS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "targetCode", {
        get: function () {
            return this.target;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "validations", {
        get: function () {
            var minRadius = GeoTargetingMenuSettingFormModel.MIN_RADIUS;
            return {
                advanced: {
                    required: function (value) {
                        return Boolean(value !== undefined && value !== '') || '入力して下さい';
                    },
                    overZero: function (value) { return Number(value) >= 0 || '0以上の数値を入力して下さい'; },
                    overOne: function (value) { return Number(value) >= 1 || '1以上の数値を入力して下さい'; },
                    overHundred: function (value) {
                        return Number(value) >= minRadius ||
                            "".concat(minRadius, "\u4EE5\u4E0A\u306E\u6570\u5024\u3092\u5165\u529B\u3057\u3066\u4E0B\u3055\u3044");
                    },
                    integer: function (value) {
                        return Number.isInteger(Number(value)) || '整数で入力して下さい';
                    },
                    withinOneYear: function (value) {
                        return Number(value) <= 365 || '365日よりも前は指定できません';
                    },
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "isOnlyResident", {
        get: function () {
            return (this.target.length === 1 && this.target.includes(MenuTargets.RESIDENT));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "availableUseS2", {
        get: function () {
            return (this.enableRadiusAutomation ||
                !(this.minutesAgo === 0 || this.isOnlyResident));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "emptyVisitCountViolation", {
        get: function () {
            return (this.target.includes(MenuTargets.VISITOR) &&
                typeof this.visitCount === 'undefined');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "zeroVisitCountViolation", {
        get: function () {
            return this.target.includes(MenuTargets.VISITOR) && this.visitCount < 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "emptyRadiusViolation", {
        get: function () {
            return (!this.enableRadiusAutomation &&
                this.enableBulkSetting &&
                typeof this.radius === 'undefined');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "lessRadiusViolation", {
        get: function () {
            return (!this.enableRadiusAutomation &&
                ((this.enableBulkSetting && this.radius < 100) ||
                    (!this.enableBulkSetting && this.deliveryLocationGroupsRadiusViolation)));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "deliveryLocationGroupsRadiusViolation", {
        get: function () {
            return this.deliveryLocationGroups.some(function (group) { return group.radius < 100; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "emptyMinutesAgoViolation", {
        get: function () {
            return this.minutesAgo === '' || this.minutesAgo == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "minusMinutesAgoViolation", {
        get: function () {
            return this.minutesAgo < 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "noTargetViolation", {
        get: function () {
            return this.target.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    GeoTargetingMenuSettingFormModel.prototype.sortUsableGroupToTop = function (a, b) {
        return b.isUsable - a.isUsable;
    };
    GeoTargetingMenuSettingFormModel.prototype.findLocationGroup = function (locationGroupId) {
        var comparator = function (g) { return g.id === locationGroupId; };
        return (this.oemLocationGroups.find(comparator) ||
            this.advertiserLocationGroups.find(comparator) ||
            this.insertionOrderLocationGroups.find(comparator) ||
            this.simulationLocationGroups.find(comparator));
    };
    GeoTargetingMenuSettingFormModel.prototype.getAllLocationGroups = function () {
        return __spreadArray(__spreadArray(__spreadArray([], this.oemLocationGroups, true), this.advertiserLocationGroups, true), this.insertionOrderLocationGroups, true);
    };
    GeoTargetingMenuSettingFormModel.prototype.addAccessibleType = function () {
        var groups = this.getAllLocationGroups();
        this.deliveryLocationGroups.forEach(function (group) {
            var locationGroup = groups.find(function (g) { return g.id === group.locationGroupId; });
            if (locationGroup === undefined)
                return;
            group.accessibleType = locationGroup.accessibleType;
        });
    };
    GeoTargetingMenuSettingFormModel.prototype.fetchLocationGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, oemLocationGroups, advertiserLocationGroups, insertionOrderLocationGroups;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            LocationGroupRepository.getList(this.systemOwnerProfileId, locationGroupType.ALL, true),
                            LocationGroupRepository.getList(this.advertiserOwnerProfileId, locationGroupType.ALL, true),
                            LocationGroupRepository.getList(this.insertionOrderOwnerProfileId, locationGroupType.ALL, true),
                        ])];
                    case 1:
                        _a = _b.sent(), oemLocationGroups = _a[0], advertiserLocationGroups = _a[1], insertionOrderLocationGroups = _a[2];
                        this.oemLocationGroups = oemLocationGroups
                            .filter(function (group) { return group.isActive; })
                            .map(this.addUsableProperty);
                        this.advertiserLocationGroups = advertiserLocationGroups
                            .filter(function (group) { return group.isActive; })
                            .map(this.addUsableProperty);
                        this.insertionOrderLocationGroups = insertionOrderLocationGroups
                            .filter(function (group) { return group.isActive; })
                            .map(this.addUsableProperty);
                        return [2 /*return*/];
                }
            });
        });
    };
    GeoTargetingMenuSettingFormModel.prototype.addUsableProperty = function (group) {
        return __assign(__assign({}, group), { isUsable: true });
    };
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "visibleDeliveryLocationGroups", {
        get: function () {
            return this.deliveryLocationGroups.filter(function (g) { return !g.deleted; });
        },
        enumerable: false,
        configurable: true
    });
    GeoTargetingMenuSettingFormModel.prototype.isActiveGroupEmpty = function () {
        return !this.deliveryLocationGroups.some(function (group) { return !group.deleted && group.accessibleType === 'public'; });
    };
    GeoTargetingMenuSettingFormModel.prototype.addDeliveryLocationGroups = function (deliveryLocationGroups) {
        var storedIds = this.deliveryLocationGroups.map(function (g) { return g.locationGroupId; });
        var storedDeletedIds = this.deliveryLocationGroups
            .filter(function (g) { return g.deleted; })
            .map(function (g) { return g.locationGroupId; });
        var toAddList = deliveryLocationGroups.filter(function (g) { return !storedIds.includes(g.locationGroupId); });
        var toRestoreIds = deliveryLocationGroups
            .filter(function (g) { return storedDeletedIds.includes(g.locationGroupId); })
            .map(function (g) { return g.locationGroupId; });
        this.deliveryLocationGroups
            .filter(function (g) { return toRestoreIds.includes(g.locationGroupId); })
            .forEach(function (g) { return (g.deleted = false); });
        this.deliveryLocationGroups = this.deliveryLocationGroups.concat(toAddList.map(DeliveryLocationGroupFormModel.assign));
    };
    GeoTargetingMenuSettingFormModel.prototype.removeDeliveryLocationGroups = function (deliveryLocationGroups) {
        var storedIds = this.deliveryLocationGroups.map(function (g) { return g.locationGroupId; });
        var toMarkDeletedIds = deliveryLocationGroups
            .filter(function (g) { return storedIds.includes(g.locationGroupId); })
            .map(function (g) { return g.locationGroupId; });
        this.deliveryLocationGroups
            .filter(function (g) { return toMarkDeletedIds.includes(g.locationGroupId); })
            .forEach(function (g) { return (g.deleted = true); });
    };
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "deliveryCreativeCount", {
        get: function () {
            return this.deliveryLocationGroups.map(function (dlg) { return dlg.creatives; }).flat().length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "hasCreative", {
        get: function () {
            return this.deliveryCreativeCount > 0;
        },
        enumerable: false,
        configurable: true
    });
    GeoTargetingMenuSettingFormModel.prototype.removeDeliveryCreatives = function () {
        this.deliveryLocationGroups.forEach(function (dlg) { return (dlg.creatives = []); });
    };
    /**
     * 全ての配信地点グループに一括半径指定する。
     * @param {number} radius
     */
    GeoTargetingMenuSettingFormModel.prototype.setRadiusToAllRadiusTarget = function (radius) {
        this.deliveryLocationGroups.forEach(function (g) { return (g.radius = radius); });
    };
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "isLimitOverDeliveryLocationGroups", {
        get: function () {
            return (this.visibleDeliveryLocationGroups.length >
                GeoTargetingMenuSettingFormModel.MAX_DELIVERY_LOCATION_GROUPS);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "isSimulatable", {
        get: function () {
            if (this.isUnderMinRadius) {
                return false;
            }
            // シミュレーション可能な地点グループが選択されていない場合は実行しない
            if (this.isActiveGroupEmpty()) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    GeoTargetingMenuSettingFormModel.prototype.hasPrivateGroup = function () {
        return this.visibleDeliveryLocationGroups.some(function (group) { return group.accessibleType !== 'public'; });
    };
    GeoTargetingMenuSettingFormModel.prototype.coerceUseS2State = function () {
        if (!this.availableUseS2) {
            this.useLowQualityLocation = false;
        }
    };
    GeoTargetingMenuSettingFormModel.prototype.setEnableBulkSetting = function (flag) {
        var _this = this;
        var hasPOIGroup = this.deliveryLocationGroups.some(function (group) { return group.locationType === locationGroupType.POI_LOCATION; });
        var radius = hasPOIGroup ? 300 : 1000;
        this.deliveryLocationGroups.forEach(function (group) { return (group.radius = _this.radius); });
        this.radius = radius;
        this.enableBulkSetting = flag;
    };
    GeoTargetingMenuSettingFormModel.prototype.setEnableRadiusAutomation = function (flag, isFromSimulation) {
        this.enableRadiusAutomation = flag;
        if (!flag) {
            this.disableRadiusAutomation(isFromSimulation);
            return;
        }
        else {
            this.optimizeGroupsRadius();
            return;
        }
    };
    GeoTargetingMenuSettingFormModel.prototype.disableRadiusAutomation = function (isFromSimulation) {
        // 半径自動最適化OFF
        this.useLowQualityLocation = Defaults.MenuSetting.useLowQualityLocation;
        this.coerceUseS2State();
        this.enableBulkSetting = Defaults.MenuSetting.enableBulkSetting;
        if (!this.isNew &&
            this.originalEnableRadiusAutomation &&
            !isFromSimulation) {
            var radius = Defaults.MenuSetting.radius;
            this.radius = radius;
            this.setDefaultRadiusForAllGroups();
        }
    };
    GeoTargetingMenuSettingFormModel.prototype.optimizeGroupsRadius = function () {
        var _this = this;
        // 各グループの半径を最適化
        if (this.originalEnableRadiusAutomation &&
            this.originalDeliveryLocationGroups.length > 0) {
            this.deliveryLocationGroups.forEach(function (group) {
                var originalGroup = _this.originalDeliveryLocationGroups.find(function (g) { return g.id === group.id; });
                if (originalGroup === undefined)
                    // 新たに追加されたグループ
                    group.radius = getDefaultRadiusByLocationType(group.locationType);
                else
                    group.radius = originalGroup.radius; // 初期状態に戻す
            });
        }
        else {
            this.setDefaultRadiusForAllGroups();
        }
    };
    GeoTargetingMenuSettingFormModel.prototype.setDefaultRadiusForAllGroups = function () {
        this.deliveryLocationGroups.forEach(function (group) {
            return (group.radius = getDefaultRadiusByLocationType(group.locationType));
        });
    };
    Object.defineProperty(GeoTargetingMenuSettingFormModel.prototype, "isNew", {
        get: function () {
            return this.id == null;
        },
        enumerable: false,
        configurable: true
    });
    GeoTargetingMenuSettingFormModel.MAX_DELIVERY_LOCATION_GROUPS = 99;
    GeoTargetingMenuSettingFormModel.MIN_RADIUS = 100;
    return GeoTargetingMenuSettingFormModel;
}());
export { GeoTargetingMenuSettingFormModel };
var getDefaultRadiusByLocationType = function (locationType) {
    switch (locationType) {
        case locationGroupType.CUSTOM_LOCATION:
            return 1000;
        case locationGroupType.POI_LOCATION:
            return 300;
        default:
            return 1000;
    }
};
